// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"pageWrap_3UZmW","selectWrap":"selectWrap_2WUQ3","pageNum":"pageNum_3LHAl","textNum":"textNum_26DDp"};